var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"support-footer-playground"},[_c('support-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }